import React, { Component } from "react";
import $ from "jquery";
import Apihelpers from "./helper/ApiHelper";
import { FORGOT_PASSWORD, NEET_HELP_EMAIL } from "./helper/Constants";
import { NavLink } from "react-router-dom";



class ForgotPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      hasEmailError: null,
      hasEmailValidateError: null,
      recoverby:"email",
      idlist:[],
      userid:''
    };
  }

  ForgotPassword = (e) => {
    e.preventDefault();
    if (this.state.hasEmailValidateError == false && this.state.hasEmailError == false) {
      let planchangeData = {
        email: this.state.email
      };
      if (this.state.recoverby == 'id') {
        planchangeData = {
          userid: this.state.userid
        };
      }
      console.log('planchangeData',planchangeData);
      Apihelpers.postdataresponse(FORGOT_PASSWORD, planchangeData).then(res => {
        if (res.data.status === true) {
          this.setState({
            isEmailsend: true,
            iserrormsz: ""
          })
          $("#email").val("")
        } else if(res.data.status === false && res.data.data.length > 0 ){
          console.log('id list',res.data.data);
          this.setState({
            recoverby: 'id',
            isEmailsend: false,
            idlist:res.data.data
          });
        //get list of client user then call again same api with userid = res.data.data[0]._id
        }
        else {
          this.setState({
            isEmailsend: false,
            iserrormsz: res.data.message
          })
        }
      });
    }
  }


  emailcheck = () => {
    if (this.state.email == "") {
      this.setState({
        hasEmailError: true
      })
    } else {
      this.setState({
        hasEmailError: false
      })
      if (!this.validateEmail(this.state.email)) {
        this.setState({
          hasEmailValidateError: true
        });
      } else {
        this.setState({
          hasEmailValidateError: false
        });
      }
    }
  }


  emailchange = (e) => {
    var email = e.target.value;
    this.setState({
      email: email
    });
  }

  clearTextbox = (e) => {
    $("#email").val("");
  }

  validateEmail(emailField) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(emailField) == false) {
      return false;
    }
    return true;

  }
  recoverChange = (e) => {
    this.setState({
      userid: e.target.value
    });
  }
  render() {
    return (
      <React.Fragment>
        <div className="wrapper">
          <div className="container">
            <div className="flexWrapper">
              <div className="loginPopUp forotPassPopUp">
                <div className="popUpLogo">
                  <img src="/assets/images/logo.png" alt="" />
                </div>
                <form className="form" method="post" onSubmit={this.ForgotPassword}>
                  <div className="form-group">
                    <h3>Forgot Your Password?</h3>
                    <div className="desc">That's ok! Simply enter your email below and a reset password link will be sent to you via email. You can then follow that link and select a new password.</div>
                  </div>
                  <div className="form-group" style={{display: (this.state.recoverby === 'id') ? 'block' : 'none'}}>
                    <label className="control-title">Recover by: {this.state.recoverby}</label>
                    {
                      this.state.idlist.map((item) => {
                        return (
                          <div className="radio-row" key={item._id}>
                            <label>
                              <input type="radio" name="recoverid" value={item._id} onClick={this.recoverChange} />
                              {item.name +' ('+item._id+')'}
                            </label>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className="form-group" style={{display: (this.state.recoverby === 'id') ? 'none' : 'block'}}>
                    <label className="control-title">E-mail:</label>
                    <input className="form-control" type="text" onBlur={this.emailcheck} id="email" placeholder='Enter Email ID' autoComplete="off" name="email" onChange={this.emailchange} />

                    {this.state.hasEmailError == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Please enter email </div> : ''}
                    {this.state.hasEmailValidateError == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Enter valid email </div> : ''}

                  </div>
                  <div className="submitRow">
                    {/* <!-- <button className="blueBtn" type="submit">Submit</button> --> */}
                    <button className="blueBtn" type="submit" >Send it to me</button>
                    {/* <a className="forGot" type="button" onClick={this.clearTextbox} >Cancel</a> */}

                    <NavLink
                      className="forGot"
                      to={"/admin/login"}
                      exact
                      activeClassName="active"
                      style={{ background: "none" }}
                    > Cancel
                      </NavLink>

                    {this.state.isEmailsend ? <div style={{ color: "darkgreen", marginTop: "20px" }}>New password has send to your email id</div> : <div />}
                    {this.state.iserrormsz ? <div style={{ color: "maroon", marginTop: "20px" }}>{this.state.iserrormsz}</div> : <div />}

                  </div>
                </form>
                <div className="bottomBg">
                  Need help?  <a href={"mailto:" + NEET_HELP_EMAIL}>{NEET_HELP_EMAIL}</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default ForgotPassword;
